const situations = [
  { icon: 'ri-task-line', title: 'Постановка задач', desc: 'Сотрудник должен понять не только «что сделать», но и принять ответственность за результат.' },
  { icon: 'ri-calendar-2-line', title: 'Изменение сроков', desc: 'Как обсуждать перенос сроков, не превращая разговор в поиск виноватых.' },
  { icon: 'ri-error-warning-line', title: 'Невыполнение договорённостей', desc: 'Как возвращать сотрудника к ответственности за принятые обязательства.' },
  { icon: 'ri-user-unfollow-line', title: 'Сложный сотрудник', desc: 'Как разговаривать с сотрудником, который сопротивляется требованиям руководителя.' },
  { icon: 'ri-bar-chart-box-line', title: 'KPI и результаты', desc: 'Как обсуждать невыполнение показателей без перехода в обвинения.' },
  { icon: 'ri-funds-line', title: 'Распределение ресурсов', desc: 'Переговоры с коллегами и другими подразделениями за людей, время, бюджет и приоритеты.' },
  { icon: 'ri-scales-3-line', title: 'Конфликты', desc: 'Как переводить эмоциональное противостояние в рабочие договорённости.' },
  { icon: 'ri-refresh-line', title: 'Изменения', desc: 'Как договариваться с командой при внедрении новых правил, процессов и технологий.' },
  { icon: 'ri-wallet-3-line', title: 'Зарплата и условия', desc: 'Как обсуждать ожидания сотрудников и интересы компании без разрушения отношений.' },
  { icon: 'ri-chat-quote-line', title: 'Непопулярные решения', desc: 'Как объяснять решения, которые не устраивают часть команды, и сохранять их выполнение.' },
];

export default function NegotiationSituations() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          В каких ситуациях руководителю приходится вести переговоры
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Типовые рабочие ситуации, где от руководителя требуется не приказ, а достигнутая договорённость
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {situations.map((item) => (
            <div key={item.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}